<template>
  <v-dialog
    v-model="display"
    persistent
    scrollable
    transition="dialog-bottom-transition"
    content-class="v-dialog-form-bottom"
  >
    <v-card flat>
      <v-card-title
        class="py-3 mb-0 justify-space-between"
        style="border-bottom: 1px solid #D3D2D2"
      >
        <div style="width:28px"></div>
        <span class="font-weight-bold">{{ title }}</span>
        <v-btn
          icon
          small
          @click="goBack"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        class="ma-0 pa-0"
      >
      <v-list class="py-0">
        <!-- Filter -->
        <!-- Filterは面倒なので、一旦コメントアウト
        <v-list-item>
          <v-list-item-content>
            <v-text-field
              label="Filter"
              v-model="filter"
              placeholder="Please input your country in English."
              hint="Please input your country's formal name in English."
              persistent-hint
            ></v-text-field>
          </v-list-item-content>
        </v-list-item>
        -->
        <v-list-item-group
          multiple
          v-model="selectedList"
        >
          <!-- SelectList -->
          <v-list-item
            v-for="item in selectList"
            :key="item"
            active-class="primary--text"
          >
            <template v-slot:default="{ active, toggle }">
              <v-list-item-content>
                <v-list-item-title
                  v-text="item"
                ></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-checkbox
                  :input-value="active"
                  :true-value="item"
                  color="primary"
                  @click="toggle"
                ></v-checkbox>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import service from '@/plugins/service'

export default {
  props: {
    value: { type: Array, required: true, },
    title: { type: String, required: true, },
    listName: { type: String, required: true, }
  },
  data: () => ({
    display: false,
    filter: '',
    selectedList: [],
    selectList: [],
    languageList: [
      'English',
      'Japanese',
      'Taiwanese',
      'Amharic',
      'Arabic',
      'Armenian',
      'Bengali',
      'Berber',
      'Burmese',
      'Chinese',
      'Danish',
      'Dutch',
      'Estonian',
      'Filipino',
      'French',
      'German',
      'Greek',
      'Gujarati',
      'Hindi',
      'Indonesian',
      'Italian',
      'Javanese',
      'Kannada',
      'Kazakh',
      'Khmer',
      'Korean',
      'Kurdish',
      'Lao',
      'Malay',
      'Malayalam',
      'Marathi',
      'Mongolian',
      'Myanmar',
      'Oriya',
      'Pashto',
      'Persian',
      'Polish',
      'Portuguese',
      'Punjabi',
      'Russian',
      'Somali',
      'Spanish',
      'Swahili',
      'Swedish',
      'Tagalog ',
      'Tamil',
      'Telugu',
      'Thai',
      'Turkish',
      'Ukranian',
      'Urdu',
      'Uzbek',
      'Vietnamese',
      'Xhosa',
      'Other',
    ],
    characterList: [
      'friendly',
      'easygoing',
      'curious',
      'talkative',
      'geek',
      'social',
      'flexible',
      'outgoing',
      'shy',
      'open-minded',
    ],
  }),
  methods: {
    show() {
      if (this.display) {
        service.log('skip')
        return
      }
      service.log('show')
      this.selectList.splice(0)
      this[this.listName].forEach(item => this.selectList.push(item))
      this.selectedList.splice(0)
      for (let i = 0 ; i < this.selectList.length ; i++) {
        if (this.value.includes(this.selectList[i])) {
          this.selectedList.push(i)
        }
      }
      this.display = true
    },
    goBack() {
      const result = []
      this.selectedList.forEach(i => result.push(this.selectList[i]))
      this.$emit('input', result)
      this.display = false
    },
  },
};
</script>
